module.exports = __webpack_public_path__ + "teqbahn-assets/media/31.cbbc8be1.png";